const config = {
  defaults: {
    namespace: 'CBJC',
  },
};

export default config;
